export const DEFAULT_LANG = 'zh-TW';
export const ZUSER_PLATFORM_ID = 'dbe66e89-2edc-55b5-9c6e-820110b08d5f';
export const ALERT_HIDE_DURATION = 3000;

export default {};
